var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m256 512c-68.38 0-132.667-26.629-181.02-74.98-48.351-48.353-74.98-112.64-74.98-181.02s26.629-132.667 74.98-181.02c48.353-48.351 112.64-74.98 181.02-74.98s132.667 26.629 181.02 74.98c48.351 48.353 74.98 112.64 74.98 181.02s-26.629 132.667-74.98 181.02c-48.353 48.351-112.64 74.98-181.02 74.98zm0-472c-119.103 0-216 96.897-216 216s96.897 216 216 216 216-96.897 216-216-96.897-216-216-216zm-1 235c-52.935 0-96-43.065-96-96s43.065-96 96-96 96 43.065 96 96-43.065 96-96 96zm0-152c-30.879 0-56 25.122-56 56s25.121 56 56 56 56-25.122 56-56-25.121-56-56-56zm126.712 268.472c8.546-6.999 9.799-19.6 2.8-28.146-28.281-34.525-70.068-54.326-114.647-54.326h-23.73c-44.579 0-86.366 19.801-114.646 54.327-6.999 8.545-5.746 21.146 2.8 28.146 8.545 7 21.146 5.745 28.146-2.799 20.65-25.214 51.158-39.674 83.7-39.674h23.73c32.542 0 63.05 14.46 83.701 39.673 3.955 4.827 9.695 7.327 15.484 7.327 4.459 0 8.945-1.483 12.662-4.528z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser3);
export default __webpack_public_path__ + "static/media/user3.ae19c03a51952e031bc98b4b5f3b81ed.svg";
export { ForwardRef as ReactComponent };